import { render, staticRenderFns } from "./ProfileTuitionCenter.vue?vue&type=template&id=60d93602&"
import script from "./ProfileTuitionCenter.vue?vue&type=script&lang=js&"
export * from "./ProfileTuitionCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports